import Box from "@/components/Box";
import Circle from "@/components/Circle";
import CustomerPage from "@/components/CustomerPage";
import CustomerTabs from "@/components/CustomerTabs";
import DataLoader from "@/components/DataLoader";
import OrdersAndTests from "@/components/OrdersAndTests";
import PartnerDashboardBox from "@/components/boxes/PartnerDashboardBox";
import OrderIcon from "@/components/orders/OrderIcon";
import Group from "@/tpo/Group";
import B2CHeader from "@/tpo/header/B2CHeader";
import { useTheme } from "styled-components";

import { USER_TESTS_AND_ORDERS_QUERY } from "./graphql";
import useCustomerTestsAndReports from "./useCustomerTestsAndReports";

export default function OrdersAndTestsRoute() {
  const theme = useTheme();
  const customerTestsAndReports = useCustomerTestsAndReports();

  return (
    <>
      <B2CHeader />
      <CustomerPage
        bg="haze"
        includeFooter
        jumbotronProps={{
          title: "Test Results"
        }}
      >
        <CustomerTabs selectedTab="/test-results" />
        <Box px={20}>
          <PartnerDashboardBox
            mt={theme.spacing.section.pt}
            mb={theme.spacing.section.pb}
            pt={theme.spacing.figma.medium}
            pb={theme.spacing.figma.large}
          >
            <Group alignItems="center" gap={20}>
              <Circle size={60} background="white" withBorder borderWidth={2}>
                <OrderIcon width={[30, 30, 40]} variant="outline" />
              </Circle>
              <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
                Tests
              </Box>
            </Group>
            <DataLoader
              query={USER_TESTS_AND_ORDERS_QUERY}
              variables={{
                allTests: true,
                excludeRetests: true
              }}
              render={({ ordersInProgress, userTests }) => (
                <OrdersAndTests
                  ordersInProgress={ordersInProgress}
                  userTests={userTests}
                  {...customerTestsAndReports}
                  showPaymentStatus={false}
                />
              )}
            />
          </PartnerDashboardBox>
        </Box>
      </CustomerPage>
    </>
  );
}
